import TYPES from './types';
import CheckoutService, {
  IShippingMethod
} from 'src/services/checkout/CheckoutService';
import CartModel from 'src/model/cart.model';
import { ICheckoutError } from './reducers';
import { cartActions } from '../cart';
import store from 'src/store';
import { selectedCardSel } from 'src/store/modules/creditcard';
import { analyticsActions } from 'src/analytics/store';


const setIsPending = (isPending: boolean) => {
  return {
    type: TYPES.SET_IS_PENDING,
    payload: isPending ? isPending : false
  };
};

const setOrderConfirmed = (orderConfirmed: boolean) => {
  return {
    type: TYPES.SET_ORDER_CONFIRMED,
    payload: orderConfirmed ? orderConfirmed : false
  };
};

const setShippingMethod = (shippingMethod: IShippingMethod) => {
  return {
    type: TYPES.SET_ORDER_SHIPPING_METHOD,
    payload: shippingMethod
  };
};

const setCreditCardUrl = (creditCardUrl: string) => {
  return {
    type: TYPES.SET_CREDIT_CARD_URL,
    payload: creditCardUrl ? creditCardUrl : null
  };
};

const setPendingOrderNumber = (pendingOrderNumber: number) => {
  return {
    type: TYPES.SET_PENDING_ORDER_NUMBER,
    payload: pendingOrderNumber ? pendingOrderNumber : null
  };
};

const setConfirmationNumber = (confirmationNumber: number) => {
  return {
    type: TYPES.SET_CONFIRMATION_NUMBER,
    payload: confirmationNumber ? confirmationNumber : false
  };
};

const setCheckoutCode = (checkoutCode: number) => {
  return {
    type: TYPES.SET_CHECKOUT_CODE,
    payload: checkoutCode ? checkoutCode : 0
  };
};

const setCart = (cart: CartModel) => {
  return {
    type: TYPES.SET_CART,
    payload: cart ? cart : {}
  };
};

const setSubtotal = (subtotal: string) => {
  return {
    type: TYPES.SET_SUBTOTAL,
    payload: subtotal ? subtotal : '0'
  };
};

const setTax = (tax: string) => {
  return {
    type: TYPES.SET_TAX,
    payload: tax ? tax : '0'
  };
};

const setTotal = (total: string) => {
  return {
    type: TYPES.SET_TOTAL,
    payload: total ? total : '0'
  };
};

const setDefaultMOT = (defaultMOT: string) => {
  return {
    type: TYPES.SET_DEFAULT_MOT,
    payload: defaultMOT ? defaultMOT : null
  };
};

const setTermsOfDelivery = (termsOfDelivery: string) => {
  return {
    type: TYPES.SET_TERMS_OF_DELIVERY,
    payload: termsOfDelivery ? termsOfDelivery : null
  };
};

const setSoftCreditHold = (softCredit: boolean) => {
  return {
    type: TYPES.SET_SOFT_CREDIT_HOLD,
    payload: softCredit
  };
};

const setError = (error?: ICheckoutError) => {
  return {
    type: TYPES.SET_ERROR,
    payload: error
      ? error
      : {
          hasFailed: false,
          message: ''
        }
  };
};

const placingOrderInProcess = (placeOrderProcess: boolean) => {
  return {
    type: TYPES.PLACE_ORDER_PROGRESS,
    payload: placeOrderProcess ? placeOrderProcess : false
  };
};

const getInfo = () => {
  return (dispatch: any) => {
    dispatch(setIsPending(true));
    dispatch(setError());
    CheckoutService.getCheckout()
      .then(response => {
        localStorage.setItem(
          'allowedUserForExtraField',
          response.allowedUserForExtraField
        );
        dispatch(setOrderConfirmed(false));

        dispatch(setCheckoutCode(response.checkoutCode));
        dispatch(setCart(response.cart));
        dispatch(setSubtotal(response.subtotal));
        dispatch(setTax(response.tax));
        dispatch(setTotal(response.total));
        dispatch(setDefaultMOT(response.defaultMOT));
        dispatch(setTermsOfDelivery(response.termsOfDelivery));
        dispatch(setIsPending(false));
        try {
          dispatch(
            analyticsActions.checkoutStep({
              products: response.cart.items,
              step: 1,
              option: response.cart.delivery
            })
          );
        } catch (waError) {
          console.log(waError);
        }
      })
      .catch(error => {
        dispatch(          
          setError({
            hasFailed: true,
            message: `Error placing order. ${
              error.response ? error.response.data : 'Error: Network Error'
            }`
          })
        );
        dispatch(setOrderConfirmed(false));
        dispatch(setIsPending(false));
      });
  };
};

const placeOrder = (
  checkoutCode: number,
  confirmationEmail: boolean,
  deliverSameTime: boolean,
  paymentMethod: string,
  poNumber: string,
  shippingMethod: IShippingMethod,
  saveCard: boolean,
  unitNumber: string,
  serviceNumer: string,
  techId: string,
  mobileNumber: string,
  emailId: string,
  isOrderEmailPhoneUpdated: boolean,
  OrderTemprary: any
) => {
  const storeData: any = store.getState();
  let OrderEmailPhoneUpdated = false;
  OrderTemprary = '';
  if(localStorage.getItem("isOrderEmailPhoneUpdated") === 'true' && (localStorage.getItem("orderPhone") || localStorage.getItem("orderEmail"))) {
      OrderEmailPhoneUpdated = true;
      OrderTemprary = 'tempNumber'+Date.now(); 
  }

  const currentUrl = window.location.pathname.split('/');
    let languageFromUrl = currentUrl[2];
    if(languageFromUrl === 'fr') {
      languageFromUrl = 'FR';
    } else {
      languageFromUrl = 'EN';
    }
    const region = currentUrl[1];
  return (dispatch: any) => {
    dispatch(placingOrderInProcess(true));
    CheckoutService.placeOrder(
      checkoutCode,
      confirmationEmail,
      deliverSameTime,
      paymentMethod,
      poNumber,
      shippingMethod.motcode,
      unitNumber,
      serviceNumer,
      techId,
      localStorage.getItem("orderPhone"),
      localStorage.getItem("orderEmail"),
      OrderEmailPhoneUpdated,
      OrderTemprary
    )
      .then(res => {
        dispatch(setOrderConfirmed(false));
        dispatch(placingOrderInProcess(false));
        dispatch(setCreditCardUrl(res.creditCardUrl));
        dispatch(setPendingOrderNumber(res.pendingOrderNumber));
        dispatch(setShippingMethod(shippingMethod));
        localStorage.removeItem('allowedUserForExtraField');
        if (paymentMethod === '001') {
          dispatch(confirmOrder('', res.pendingOrderNumber,'','',OrderEmailPhoneUpdated,languageFromUrl, region, saveCard));
        } else if (paymentMethod === '004') {
          dispatch(
            confirmOrder(
              selectedCardSel(storeData).id,
              res.pendingOrderNumber,
              localStorage.getItem("orderPhone"),
              localStorage.getItem("orderEmail"),
              OrderEmailPhoneUpdated, 
              languageFromUrl,
              region,  
              saveCard
            )
          );
        }
      })
      .catch(err => {
        dispatch(setOrderConfirmed(false));
        dispatch(placingOrderInProcess(false));
        dispatch(
          setError({
            hasFailed: true,
            message:
              'Error placing order. ' + (err.response ? err.response.data : err)
          })
        );
      });
  };
};

const confirmOrder = (
  paymentConfirmation: string,
  pendingOrderId: number,
  mobileNumber: string,
  emailId: string,
  isOrderEmailPhoneUpdated: boolean,
  language: string,
  region: string,
  saveCard: boolean
) => {
  const storeData: any = store.getState();
  return (dispatch: any) => {
    dispatch(setIsPending(true));
    let OrderEmailPhoneUpdated = false;
     if(localStorage.getItem("isOrderEmailPhoneUpdated") === 'true') {
        OrderEmailPhoneUpdated = true;
     }
     const currentUrl = window.location.pathname.split('/');
     let languageFromUrl = currentUrl[2];
     if(languageFromUrl === 'fr') {
       languageFromUrl = 'FR';
     } else {
       languageFromUrl = 'EN';
     }
     CheckoutService.confirmOrder(paymentConfirmation, pendingOrderId,localStorage.getItem("orderPhone"),
     localStorage.getItem("orderEmail"), isOrderEmailPhoneUpdated,languageFromUrl, currentUrl[1], saveCard)
      .then(res => {
        dispatch(setIsPending(false));
        dispatch(setOrderConfirmed(true));
        dispatch(setConfirmationNumber(res.orderConfirmationId));
        dispatch(setSoftCreditHold(res.softCreditHold));
        dispatch(cartActions.getInfo());
        try {
          dispatch(
            analyticsActions.placeOrderConfirmation({
              res,
              shipping: storeData.checkout.termsOfDelivery
            })
          );
          dispatch(
            analyticsActions.checkoutStep({
              products: res.orderInfo.items,
              step: 2,
              option:
                storeData.googleAnalytics.paymentMethod || 'Pay By Account',
              shippingMethod:
                storeData.cart.delivery === 'Shipping' &&
                storeData.checkout.shippingMethod
            })
          );
        } catch (waError) {
          console.log(waError);
        }
      })
      .catch(err => {
        dispatch(setIsPending(false));
        dispatch(setOrderConfirmed(false));
        dispatch(
          setError({
            hasFailed: true,
            message:
              "Couldn't Confirm Order. " +
              (err.response && err.response.data ? err.response.data : '')
          })
        );
      });
  };
};

export default {
  setCheckoutCode,
  setCart,
  setSubtotal,
  setTax,
  setTotal,
  setDefaultMOT,
  setTermsOfDelivery,
  setError,
  setIsPending,
  setOrderConfirmed,
  setConfirmationNumber,
  getInfo,
  placeOrder,
  confirmOrder,
  placingOrderInProcess
};
